module.exports = {
    GoogleDownloadAddress:'https://play.google.com/store/apps/details?id=com.amicable.advance&referrer=utm_source%3Dofficial%2520website%26utm_content%3D1%26anid%3Dadmob',
    AppleDownloadAddress:'https://apps.apple.com/cn/app/advantrade/id1586086393',
    AndroidDownloadAddress:'https://apk.rongks.com/advantrade/download/Advantrade_Official_release.apk'
};
  